import React from 'react'
import { TrackingProvider } from '@indeed/flex-tracking-context'
import type { RouteComponentProps } from 'react-router-dom'

import { EmployerBlocksList as EmployerBlocksListEntity } from 'syft-acp-core/entities/EmployerDetail/EmployerBlocksList'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

type Props = RouteComponentProps<{
  id: string
}>

export const EmployerBlocksList = ({ match: { params } }: Props) => (
  <TrackingProvider
    value={{
      context: {
        employer_id: Number(params.id),
      },
    }}
  >
    <div className="page entity-list">
      <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
      <EmployerBlocksListEntity employerID={Number(params.id)} />
    </div>
  </TrackingProvider>
)
